/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through E2E */ /**
 * The entrypoint for the support form shortcode.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/lib/antd.scss";
import "./style/shortcode/supportForm/style.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready, whenInView } from "@devowl-wp/react-utils";
import { Provider } from "./components/provider.js";
import { SupportForm } from "./shortcode/supportForm/form.js";
ready().then(()=>{
    // Iterate over the DOM nodes and render a React component into each node
    const elements = document.querySelectorAll("div.real-commerce-support-form");
    elements.forEach((item)=>whenInView(item).then(()=>createRoot(item).render(/*#__PURE__*/ _jsx(Provider, {
                configProvider: {
                    locale: {
                        locale: ""
                    }
                },
                children: /*#__PURE__*/ _jsx(SupportForm, {
                    ...$(item).data()
                })
            }))));
});
